import { put, takeLatest, all, call } from "redux-saga/effects";
import { setLoading, removeLoading, parseJwt } from "../../utils";
import { post, get, patch } from "../../api";
import {
  ADD_PROMO,
  GET_PROMO,
  VIEW_PROMO,
  VIEW_PROMO_SUCCESS,
  GET_PROMO_SUCCESS,
  EDIT_PROMO,
  DELETE_PROMO,
} from "../constants";
import { VIEW_PROMO as VIEW_PROMO_ROUTE } from "../../constants";

import { GET_SALON_DETAILS as GET_SALON_DETAILS_API } from "../../api/endpoints";

function* addPromoCodes({ payload }) {
  setLoading();
  const userDetails = parseJwt();
  const { salon_id } = userDetails;
  const baseApi = `${GET_SALON_DETAILS_API}${salon_id}/salon_promo_codes/`;
  const respo = yield call(post, {
    endpoint: baseApi,
    params: { salon_promo_codes: payload },
  });
  if (respo) {
    document.querySelectorAll(".message")[0].innerHTML =
      "Promo add successfully, navigating to View Promo Codes";
    document.querySelectorAll(".service-add-success-button")[0].click();
  } else {
    document.querySelectorAll(".message")[0].innerHTML =
      "Promo not added successfully";
    document.querySelectorAll(".service-add-success-button")[0].click();
    return;
  }
  window.setTimeout(() => {
    window.location.href = `${VIEW_PROMO_ROUTE}`;
  }, 2000);
  removeLoading();
}

function* viewSalonPromoCodes() {
  setLoading();
  const userDetails = parseJwt();
  const { salon_id } = userDetails;
  const baseApi = `${GET_SALON_DETAILS_API}${salon_id}/salon_promo_codes/`;
  const {
    data: { salon_promo_codes },
  } = yield call(get, baseApi);

  yield put({ type: VIEW_PROMO_SUCCESS, data: salon_promo_codes });

  removeLoading();
}

function* getPromoDetails({ payload: { promoId } }) {
  setLoading();
  const userDetails = parseJwt();
  const { salon_id } = userDetails;
  const baseApi = `${GET_SALON_DETAILS_API}${salon_id}/salon_promo_codes/${promoId}`;
  const {
    data: { salon_promo_code },
  } = yield call(get, baseApi);
  yield put({ type: GET_PROMO_SUCCESS, data: salon_promo_code });
  // window.location.href = `${VIEW_PROMO_ROUTE}`;
  removeLoading();
}

function* editPromoDetails({ payload: { promoId, promo } }) {
  setLoading();
  const userDetails = parseJwt();
  const { salon_id } = userDetails;
  const baseApi = `${GET_SALON_DETAILS_API}${salon_id}/salon_promo_codes/${promoId}`;

  const respo = yield call(patch, {
    endpoint: baseApi,
    params: { salon_promo_codes: promo },
  });

  if (respo) {
    document.querySelectorAll(".message")[0].innerHTML =
      "Promo updated successfully, navigating to View Promo Codes";
    document.querySelectorAll(".service-add-success-button")[0].click();
  } else {
    document.querySelectorAll(".message")[0].innerHTML = "Promo not updated";
    document.querySelectorAll(".service-add-success-button")[0].click();
    window.setTimeout(() => {
      window.location.href = `${VIEW_PROMO_ROUTE}`;
    }, 2000);
    return;
  }
  window.setTimeout(() => {
    window.location.href = `${VIEW_PROMO_ROUTE}`;
  }, 2000);
  removeLoading();
}

function* deletePromoCode({ payload: { deletePromo } }) {
  setLoading();
  const userDetails = parseJwt();
  const { salon_id } = userDetails;
  const baseApi = `${GET_SALON_DETAILS_API}${salon_id}/salon_promo_codes/${deletePromo.id}`;

  const respo = yield call(patch, {
    endpoint: baseApi,
    params: {
      salon_promo_codes: {
        discount_type: `${deletePromo.discount.type}_discount`,
        active: false,
      },
    },
  });

  if (respo) {
    window.setTimeout(() => {
      window.location.href = `${VIEW_PROMO_ROUTE}`;
    }, 2000);
  } else {
    document.querySelectorAll(".message")[0].innerHTML = "Promo not deleted";
    document.querySelectorAll(".service-add-success-button")[0].click();
    window.setTimeout(() => {
      window.location.href = `${VIEW_PROMO_ROUTE}`;
    }, 2000);
    return;
  }
  removeLoading();
}

function* actionWatcher() {
  yield takeLatest(ADD_PROMO, addPromoCodes);
  yield takeLatest(VIEW_PROMO, viewSalonPromoCodes);
  yield takeLatest(GET_PROMO, getPromoDetails);
  yield takeLatest(EDIT_PROMO, editPromoDetails);
  yield takeLatest(DELETE_PROMO, deletePromoCode);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
